import { createContext, useContext, useState, ReactNode, useEffect } from "react";

interface VibeContextType {
  isVibeMode: boolean;
  toggleVibeMode: () => void;
  enableVibeMode: () => void;
  disableVibeMode: () => void;
}

const VibeContext = createContext<VibeContextType | undefined>(undefined);

export function VibeProvider({ children }: { children: ReactNode }) {
  const [isVibeMode, setIsVibeMode] = useState<boolean>(() => {
    const stored = localStorage.getItem("actrus-vibe-mode");
    return stored === "true";
  });

  useEffect(() => {
    localStorage.setItem("actrus-vibe-mode", String(isVibeMode));
  }, [isVibeMode]);

  const enableVibeMode = () => setIsVibeMode(true);
  const disableVibeMode = () => setIsVibeMode(false);
  const toggleVibeMode = () => setIsVibeMode(prev => !prev);

  return (
    <VibeContext.Provider 
      value={{ 
        isVibeMode, 
        toggleVibeMode, 
        enableVibeMode, 
        disableVibeMode 
      }}
    >
      {children}
    </VibeContext.Provider>
  );
}

export function useVibe() {
  const context = useContext(VibeContext);
  if (!context) {
    throw new Error("useVibe must be used within VibeProvider");
  }
  return context;
}
